/** define variables and objects ***/
var selectorClassError 			= 'error';
var selectorClassSuccess		= 'success';

var selectorClassFormItem 		= 'form__item';
var selectorClassFormInputItem 	= '.form-item__input';
var selectorClassErrorMessage	= '.errormessage';

/* HTML Trigger attributes */
var AttrRequireTrigger	= 'verplicht';
var AttrValType			= 'valtype';
var AttrMinChar			= 'minchar';
var AttrTransform		= 'transform';

/*** Values error messages ***/
//var errorMessagesJSON = 
//{
     
//	'StrErrorMsgTxtCheckbox' : { '_default':'Het lijkt erop dat u niet akkoord bent gegaan met de algemene voorwaarden' },
//	'StrErrorMsgTxtInitials' : { '_default' : 'Het lijkt erop dat uw voorletters niet zijn aangegeven' },
//	'StrErrorMsgTxtLastName': { '_default': 'Het lijkt erop dat uw achternaam niet is aangegeven' },
//	'StrErrorMsgTxtFirstName': { '_default': 'Het lijkt erop dat uw voornaam niet is aangegeven' },
//	'StrErrorMsgTxtEmail' : { '_default' : 'Het lijkt erop uw e-mailadres niet volledig is ingevuld', '_validate' : 'Het lijkt erop dat dit geen geldig e-mailadres is' },
//	'StrErrorMsgTxtZipcode' : {
//		'_default' : 'Het lijkt erop dat de postcode niet volledig is ingevoerd',
//		'_validate' : 'Het lijkt erop dat de postcode niet juist is ingevoerd. Voorbeeld: 1234AB',
//		'_area' : 'Uw postcode bevindt zich buiten het verspreidingsgebied van deze krant.' },
//	'StrErrorMsgRadioGender' : { '_default' : 'Het lijkt erop dat uw aanhef niet is aangegeven' },
//	'StrErrorMsgRadioGift' : { '_default' : 'Het lijkt erop dat u niet heeft aangegeven of u een welkomstgeschenk wilt ontvangen' },
//	'StrErrorMsgStreetNumber' : { '_default' : 'Het lijkt erop dat uw huisnummer niet is aangegeven' },
//	'StrErrorMsgStreet' : { '_default' : 'Het lijkt erop dat uw straat niet is aangegeven' },
//	'StrErrorMsgCity': { '_default': 'Het lijkt erop dat uw stad niet is aangegeven' },
//	'StrErrorMsgCountry': { '_default': 'Het lijkt erop dat uw land niet is aangegeven' },
//	'StrErrorMsgTxtPhoneCount' : { '_default' : 'Het aantal cijfers van het netnr en telefoonnr samen moet 10 cijfers zijn' },
//	'StrErrorMsgTxtPhoneNumber' : { '_default' : 'Het lijkt erop dat dit telefoonnummer niet juist is.' },
//	'StrErrorMsgTxtNetNumber' : { '_default' : 'Het lijkt erop dat uw netnummer is onjuist. Voorbeeld: 072' },
//	'StrErrorMsgPassword' : { '_default' : 'Het lijkt erop dat uw wachtwoord niet juist is aangegeven, misschien te weinig karakters (min. 6) of typefout?', '_match' : 'Het lijkt erop dat de aangegeven wachtwoorden niet overeen komen' },
//	'StrErrorMsgTxtPasswordEmpty' : { '_default' : 'Het lijkt erop dat uw wachtwoord niet juist is aangegeven, misschien te weinig karakters (min. 6) of typefout?' },
//	'StrErrorMsgTxtPasswordMatch' : { '_default' : 'Het lijkt erop dat de aangegeven wachtwoorden niet overeen komen' }
//};

// Collect all inputfields
var errorHandler = {
	fieldCollection: document.getElementsByTagName('input'),
};

/*

	************ Transformer ***********
	
	Transform input text
	------------------------------------
	
	In HTML one can call these functions 
	by using attributes in the input tag

	- transform="uppercase"
	- transform="lowercase"
	- transform="firstupper"

*/

/*** Process transformation on input values ***/
var Transformer = function () {

	/*** Define options ****/
	this.options = {
		// Transform characters to uppercase
		uppercase: function () {
			return arguments[0].toUpperCase();
		},
		// Transform characters to lowercase
		lowercase: function () {
			return arguments[0].toLowerCase();
		},
		// Transform first characters to uppercase the rest to lowercase
		firstupper: function () {
			var inputValue = '';
			inputValue = arguments[0].toLowerCase();
			inputValue = inputValue.charAt(0).toUpperCase() + inputValue.slice(1);
			return inputValue;
		}

	};

	var inputItem = arguments[0]; // eslint-disable-line prefer-destructuring

	// Get defined transform value
	var TransformValue = inputItem.getAttribute(AttrTransform);

	switch (TransformValue) {
		case 'uppercase'	: inputItem.value = this.options.uppercase(inputItem.value); break;
		case 'lowercase'	: inputItem.value = this.options.lowercase(inputItem.value); break;
		case 'firstupper'	: inputItem.value = this.options.firstupper(inputItem.value); break;
	}
};

/*** Process transformation on input values ***/

/*

	************ Restrictor ************
	
	Restrict input text 
	------------------------------------
	
	In HTML one can call these functions 
	by using attributes in the input tag

	- numeric="numeric" > numeric only
	- nospaces="nospaces" > disable spaces
	- maxlength="[value]" > bugfix on 
	  maxlength for type="number"
	
*/
var Restrictor = function (thisOriginal, event, restriction)
{

	this.options = {

		numeric: function () {

			// Ensure that it is a number and stop the keypress
			// Numbers and NumPad
			if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105)) {
				return true;
			} else {
				event.preventDefault();
				return false;	// key is not a number 
			}
		},
		maxlength: function () {

			// Get maxlength value
			var maxlength = thisOriginal.getAttribute('maxlength');
			if (maxlength <= thisOriginal.value.length) {
				return false;	// max amount has been reached
			} else {
				return true;	// max amount has not been reached
			}

		},
		nospaces: function () {

			// Disable spacebar
			if (event.keyCode === 32) event.preventDefault();

		}
	};

	var keyCodeArray = [46, 8, 9, 27, 13, 110, 190];

	if (
		// Allow: backspace, delete, tab, escape, enter and .
		keyCodeArray.includes(event.keyCode) ||
		// Allow: home, end, left, right, down, up
		(event.keyCode >= 35 && event.keyCode <= 40))
	{
		// No Action
	} else {

		switch (restriction) {

			case 'numeric':
				// Call numeric function from options
				return this.options.numeric(event);
			case 'maxlength':
				// Call maxlength function from options	
				return this.options.maxlength(thisOriginal, event);
			case 'nospaces':
				// Call nospaces function from options
				return this.options.nospaces(event);
		}
	}
};

/*

	************ Validator ************
	
	Validate input text 
	------------------------------------
	
	In HTML one can call these functions 
	by using attributes in the input tag
	
	Valtype
	------------------------------------
	- valtype="zipcode"
	- valtype="email"
	
*/

/* Function to process all the validations */
var Validator = function () {

	/*** Set variables ***/
	var ValidatorThis = this;
	var inputItem = arguments[0]; // eslint-disable-line prefer-destructuring
	var inputObject = {
		inputItem: inputItem,
		errormessage_type: '_default'
	};

	/*** Define options ***/
	this.options = {

		zipcode: function () {

			var result = {};

			// Define Reg Values
			var inputValueReg = /^([0-9]{4,})([A-Z]{2})?$/;

			// Check is Value is a valid Zipcode
			result.success = !this.value.match(inputValueReg) || this.value === '' ? false /* Invalid Zipcode */ : true; /* Valid Zipcode */
			result.errormessage_type = '_validate';

			/*** 
			
				Distribution Area Check 

			***/

			return result;
		},
		email: function () {
			var result = {};

			// Define Reg Values
			// var inputValueReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
			var inputValueReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

			// Check if value is a valid emailaddress
			result.success = !inputItem.value.match(inputValueReg) || inputItem.value === '' ? false /* Invalid Emailadres */ : true; /* Valid Emailadres */
			result.errormessage_type = '_validate';

			return result;

		}

	};

	this.required = {

		/*** Check for minimal amount of characters ***/
		MinChar: function () {

			var result = {};
			result.success = true;

			var minCharTrigger = this.hasAttribute(AttrMinChar);

			if (minCharTrigger === true) {
				var strLength = this.value.length;
				var minLength = this.getAttribute(AttrMinChar);
				result.success = strLength < minLength || this.value === '' ? false /* Minimal Amount has not been reached */ : true /* Minimal lenght has been reached */;
			}
			
			return result;

		},
		/*** Check for info type and validate ***/
		valType: function () {

			var result = {};
			result.success = true;

			var minValTypeTrigger = inputItem.hasAttribute(AttrValType);
			var inputType = inputItem.getAttribute('type');

			if (minValTypeTrigger === true) {
				// Get valtype from attribute
				switch (inputItem.getAttribute(AttrValType)) {
					case 'zipcode':
						// Call zipcode validation from Validator
						result = ValidatorThis.options.zipcode.call(this);
						break;
					case 'email':
						// Call email validation from Validator
						result = ValidatorThis.options.email.call(this);
						break;
				}
			}

			if (inputType && inputItem.value !== '') {
				// Get valtype from attribute
				switch (inputType) {
					case 'email':
						// Call email validation from Validator
						result = ValidatorThis.options.email.call(this);
						break;
				}
			}
			return result;
		}
	};

	/***** Actual error handling *****/
	if (inputObject.inputItem.getAttribute(AttrRequireTrigger) !== undefined && inputObject.inputItem.getAttribute('disabled') === null)
	{

		var ArrResult = [];

		var result = {};
		result.success = true;

		switch (inputObject.inputItem.type) {
			case 'checkbox':
				result.success = checkOptionList.call(inputObject.inputItem);
				break;
			case 'radio':
				result.success = checkOptionList.call(inputObject.inputItem);
				break;
			case 'password':
				result.success = checkInputPassword.call(inputObject.inputItem);
				break;
		}

		ArrResult[1] = this.required.MinChar.call(inputObject.inputItem);
		ArrResult[2] = this.required.valType.call(inputObject.inputItem);
		ArrResult[3] = result.success;

		// Validate on minimal amount of characters
		if (ArrResult[1].success === false) {

			inputObject.errormessage_type = '_default';
			inputObject.success = false;

		} else {

			inputObject.success = true;

			// Validate format
			if (ArrResult[2].success === false) {

				inputObject.errormessage_type = ArrResult[2].errormessage_type;
				inputObject.success = false;

			} else {

				inputObject.success = true;

				if (typeof ArrResult[3] === 'object') {
					inputObject.success = ArrResult[3].success;
					if(ArrResult[3].errormessage_type) {
						inputObject.errormessage_type = ArrResult[3].errormessage_type;
					}
				} else if (typeof ArrResult[3] === 'boolean') {
					inputObject.success = ArrResult[3];
				}
			}
		}

		/*** Assign the classes to show results error/correct ***/
		assignResultClasses.call(inputObject);

		return inputObject.success;

	} else { 
		/* No Actions */ 
	}
};

// Add Validator to ErrorHandler
errorHandler.Validator = Validator;

// Add Transformer to ErrorHandler
errorHandler.Transformer = Transformer;

// Add Transformer to ErrorHandler
errorHandler.Restrictor = Restrictor;

var intErrorAmount = 0;

// Vanilla Document Ready Listener
document.addEventListener('DOMContentLoaded', function () {

	'use strict';

	// Restrict to numeric characters only in input
	[].forEach.call(document.querySelectorAll('input[type="number"]'), function (el) {
		el.addEventListener('keydown', function (event) {
			return errorHandler.Restrictor(this, event, 'numeric');
		});
	});

	// Restrict input in length
	[].forEach.call(document.querySelectorAll('input[maxlength]'), function (el) {
		el.addEventListener('keydown', function (event) {
			return errorHandler.Restrictor(this, event, 'maxlength');
		});
	});

	// Restrict spaces in input
	[].forEach.call(document.querySelectorAll('input[nospaces]'), function (el) {
		el.addEventListener('keydown', function (event) {
			return errorHandler.Restrictor(this, event, 'nospaces');
		});
	});


	// Start test on keys, with some exeptions...
	[].forEach.call(document.querySelectorAll('input, textarea'), function (el) {
		el.addEventListener('keyup', function (event) {

			var char = event.which || event.keyCode;

			switch (char) {
				case 8: 	// backspace
				case 46: 	// Delete
				case 37: 	// Arrow Left
				case 39: 	// Arrow Right
				case 9: 	// Tab
					// No action		
					break;

				default:
					// Start validating on keystroke
					errorHandler.Transformer(this);
					break;
			}

			errorHandler.Validator(this);

		});
	});

	// Validate input and select - Added change listener for datepickers
	[].forEach.call(document.querySelectorAll('input, select'), function (el) {
		el.addEventListener('change', function () {
			errorHandler.Validator(this);
		});
	});

	// Validate Radiobuttons - Using A href to broaden the hotspot
	[].forEach.call(document.querySelectorAll('input[type=checkbox], input[type=radio]'), function (el) {
		el.addEventListener('click', function () {
			errorHandler.Validator(this);
		});
	});

	// Run validation on all forms except checkout form
	var forms = document.querySelectorAll('form');
	[...forms].forEach(form => {
		if (form.id !== 'ordersubmit' && form.id !== 'cookieWarningForm' && !form.classList.contains('no-validate')) {
			form.addEventListener('submit', event => {
				event.preventDefault();

				intErrorAmount = 0;

				const allinputFields = form.querySelectorAll('input, select, textarea');
				[...allinputFields].forEach(input => {
					errorHandler.Validator(input);
				});

				const validSubmitEvent = new Event('validFormSubmit');
				if (intErrorAmount === 0) {
					form.dispatchEvent(validSubmitEvent);
					form.submit();
				} else {
					console.warn('The number of errors is:' + intErrorAmount);
				}
			});
		}
	});

	// Run validation for checkout form
	var ordersubmit = document.getElementById('ordersubmit');

	if (ordersubmit) {
		ordersubmit.addEventListener('submit', event => {
			event.preventDefault();

			if(ordersubmit.submitterDirection) {
				const direction = ordersubmit.submitterDirection;
				if(direction === 'previous' || direction === 'next') {
					const checkoutDirection = ordersubmit.submitterId;
					const checkoutDirectionInput = ordersubmit.querySelector('.checkout-direction');
					if(checkoutDirectionInput) {
						checkoutDirectionInput.name = checkoutDirection;
						checkoutDirectionInput.id = checkoutDirection;
					}
					if(direction === 'previous') {
						ordersubmit.submit();
						return;
					}
				}
			}

			intErrorAmount = 0;

			// $('#ordersubmit input, #ordersubmit select, #ordersubmit textarea').each(function () {
			// 	errorHandler.Validator(this);
			// });

			const allinputFields = ordersubmit.querySelectorAll('input, select, textarea');
			[...allinputFields].forEach(input => {
				errorHandler.Validator(input);
			});

			if (intErrorAmount === 0) {
				ordersubmit.submit();
			} else {
				console.warn('The number of errors is: ' + intErrorAmount);
			}
		});
	}

});

/**** Shame *****/

function checkOptionList() {

	var result = { success: true };

	if (this.hasAttribute(AttrRequireTrigger)) {
		var fieldName = this.getAttribute('name');
		const allInputFields = [...document.querySelectorAll(`input[name="${fieldName}"]`)];
		result.success = allInputFields.some(field => field.checked);
	}

	return result;
}


function checkInputPassword() {

	// Get all password fields 
	const passwordField = document.querySelector('[name="EcomUserCreatePassword"]') || document.querySelector('[name="UserManagement_Form_NewPassword"]');
	const passwordConfirmField = document.querySelector('[name="EcomUserCreateConfirmPassword"]') || document.querySelector('[name="UserManagement_Form_NewPasswordConfirm"]');

	if(!passwordField || !passwordConfirmField) {
		return;
	}
	
	// Array of password fields
	const passwordFields = [
		passwordField, 
		passwordConfirmField
	];

	const isEqualPassword = passwordField.value === passwordConfirmField.value;
	const bothHaveEnoughCharacters = passwordField.value.length >= 6 && passwordConfirmField.value.length >= 6;
	const hasEnoughCharacters = this.value.length >= 6;

	// Loop through password fields and get the parent error message element, store this in Array
	const errorMessageContainers = passwordFields.map(element => fetchErrorMessageContainer.call(element));

	if(hasEnoughCharacters) {
		const errorMessageContainer = fetchErrorMessageContainer.call(this);
		errorMessageContainer.querySelector(selectorClassFormInputItem).classList.remove(selectorClassError);
		errorMessageContainer.querySelector(selectorClassFormInputItem).classList.add(selectorClassSuccess);
		errorMessageContainer.querySelector(selectorClassErrorMessage).innerHTML = '';
	} else {
		const errorMessageContainer = fetchErrorMessageContainer.call(this);
		const inputObject = {
			success: hasEnoughCharacters,
			errormessage_type: '_minchar',
			inputItem: this
		};
		errorMessageContainer.querySelector(selectorClassFormInputItem).classList.remove(selectorClassSuccess);
		errorMessageContainer.querySelector(selectorClassFormInputItem).classList.add(selectorClassError);	
		errorMessageContainer.querySelector(selectorClassErrorMessage).innerHTML = error_message.call(inputObject);
		return inputObject;
	}

	if (bothHaveEnoughCharacters) {
		if(isEqualPassword) {
			errorMessageContainers.forEach(errorMessage => {
				errorMessage.querySelector(selectorClassFormInputItem).classList.remove(selectorClassError);
				errorMessage.querySelector(selectorClassFormInputItem).classList.add(selectorClassSuccess);
				errorMessage.querySelector(selectorClassErrorMessage).innerHTML = '';
			});
		} else {
			errorMessageContainers.forEach(errorMessage => {
				errorMessage.querySelector(selectorClassFormInputItem).classList.remove(selectorClassSuccess);
				errorMessage.querySelector(selectorClassFormInputItem).classList.add(selectorClassError);
			});

			// Clear error messages on first password field
			errorMessageContainers[0].querySelector(selectorClassErrorMessage).innerHTML = '';

			const inputObject = {
				success: isEqualPassword,
				errormessage_type: '_match',
				inputItem: passwordConfirmField
			};
			
			// Display error message on password confirm field
			errorMessageContainers[1].querySelector(selectorClassErrorMessage).innerHTML = error_message.call(inputObject);
			return inputObject;
		}
		return isEqualPassword;
	}
	return true;
}

/* Get Error message from JSON file */
function error_message()
{

	if(this.inputItem.getAttribute('errorAlias') !== undefined){
		
		// Catch value of attribute
		var errorAlias = this.inputItem.getAttribute('errorAlias');

		if(errorAlias !== null){
			var ArrErrorValue = (errorMessagesJSON[errorAlias][this.errormessage_type]);
		}

		// Return the first value
		return ArrErrorValue;	
	
	}

}

function assignResultClasses()
{

	var errorMessageContainer = {};

	errorMessageContainer = fetchErrorMessageContainer.call(this.inputItem);

	if (errorMessageContainer !== false) {
	
		const inputType = this.inputItem.getAttribute('type') || this.inputItem.tagName.toLowerCase();
		switch (this.success) {

			case true:
				switch (inputType) {
					case 'text':
					case 'password':
					case 'email':
					case 'tel':
					case 'search':
					case 'url':
					case 'number':
					case 'file':
					case 'date':
					case 'datetime':
					case 'datetime-local':
					case 'time':
					case 'week':
					case 'month':
					case 'checkbox':
					case 'textarea':
					case 'select':
						if(errorMessageContainer.querySelector(selectorClassFormInputItem)) {
							errorMessageContainer.querySelector(selectorClassFormInputItem).classList.remove(selectorClassError);
							errorMessageContainer.querySelector(selectorClassFormInputItem).classList.add(selectorClassSuccess);
						}

						if (errorMessageContainer.querySelector(selectorClassErrorMessage) != null) {
							errorMessageContainer.querySelector(selectorClassErrorMessage).innerHTML = '';
						}

						break;

					case 'radio':
						if(errorMessageContainer.querySelector(selectorClassFormInputItem)) {
							errorMessageContainer.querySelector(selectorClassFormInputItem).classList.remove(selectorClassError);
							errorMessageContainer.querySelector(selectorClassFormInputItem).classList.add(selectorClassSuccess);
						}

						if (errorMessageContainer.querySelector(selectorClassErrorMessage) != null) {
							errorMessageContainer.querySelector(selectorClassErrorMessage).innerHTML = '';
						}

						[].forEach.call(errorMessageContainer.querySelectorAll(selectorClassFormInputItem), function(el) {
							el.classList.remove(selectorClassError);

							if (el.checked === true) {
								this.classList.add(selectorClassSuccess);	
							}
						});

						break;
				}
				break;

			case false:
				switch (inputType) {
					case 'text':
					case 'password':
					case 'email':
					case 'tel':
					case 'search':
					case 'url':
					case 'number':
					case 'file':
					case 'date':
					case 'datetime':
					case 'datetime-local':
					case 'time':
					case 'week':
					case 'month':
					case 'checkbox':
					case 'textarea':
					case 'select':
						if(errorMessageContainer.querySelector(selectorClassFormInputItem)) {
							errorMessageContainer.querySelector(selectorClassFormInputItem).classList.remove(selectorClassSuccess);
							errorMessageContainer.querySelector(selectorClassFormInputItem).classList.add(selectorClassError);
						}

						break;

					case 'radio':
						if(errorMessageContainer.querySelector(selectorClassFormInputItem)) {
							errorMessageContainer.querySelector(selectorClassFormInputItem).classList.remove(selectorClassSuccess);
							errorMessageContainer.querySelector(selectorClassFormInputItem).classList.add(selectorClassError);
						}

						[].forEach.call(errorMessageContainer.querySelectorAll(selectorClassFormInputItem), function(el) {
							el.classList.remove(selectorClassSuccess);
							el.classList.add(selectorClassError);
						});

						break;
				}

				intErrorAmount = intErrorAmount + 1;

				if(error_message.call(this) !== 'undefined'){
					errorMessageContainer.querySelector(selectorClassErrorMessage).innerHTML = error_message.call(this);
				}

				break;
		}

	}

}

function fetchErrorMessageContainer() {
	let errorMessageContainer = this;
	
	while (!errorMessageContainer.classList.contains(selectorClassFormItem)) {
		errorMessageContainer = errorMessageContainer.parentNode;
		if (typeof errorMessageContainer.getAttribute === 'undefined') { 
			return false;
		}
	}

	if (errorMessageContainer.classList.contains(selectorClassFormItem)) { 
		return errorMessageContainer;
	}

}
